import React from "react";
import { Card } from "antd";
import Title from "antd/es/skeleton/Title";
import { MyLogo } from "Components/MyLogo/MyLogo";
import { LoginForm } from "Pages/LoginPage/components/LoginForm/LoginForm";

export const LoginPage = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        background:
          "linear-gradient(135deg, #141414 0%, #1f1f1f 50%, #000 100%)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 20,
      }}
    >
      <Card
        style={{
          width: 420,
          borderRadius: 16,
          border: "1px solid rgba(255,255,255,.06)",
        }}
      >
        <div
          style={{
            textAlign: "center",
            marginBottom: 28,
          }}
        >
          <MyLogo
            fontSize={22}
            display="inline-flex"
            borderRadius={10}
            padding="10px 22px"
          />

          <div style={{ marginTop: 18 }}>
            <Title level={3} style={{ marginBottom: 4 }}>
              Увійти в систему
            </Title>
          </div>
        </div>

        <LoginForm />
      </Card>
    </div>
  );
};
